module.exports = "/**\r\n * Created by YingJieCHAI on 2017/11/15.\r\n */\r\n\r\n/*这个css放footer的样式*/\r\n"